export const ViewportEnum = Object.freeze({
	SM: 640,
	MD: 768,
	LG: 1024,
	XL: 1280,
	XL2: 1536,
	XL3: 1920,
});
